import { get } from 'lodash';
// 
import store from '../../../store';
// this function compare to objects and return the identifiers of the changes made
export default function (oldData, newData) {
    if(!oldData || !newData) {
        return "";
    }
    
    const users = Object.entries(newData || {});

    const changes = [];
    console.log('oldData', oldData);
    console.log('newData', newData);
    for(let [userId, user] of users) {
        
        if(!oldData[userId]) {
            console.log('user added', user);
            const panelDetails = buildNewUserPanels(user);
            changes.push(`User ${user.FirstName} ${user.LastName} added to the signatory matrix${panelDetails}`);
            continue;
        }

        const oldUser = oldData[userId];
        const panelChanges = comparePanelChanges(Object.values(user.Panels), Object.values(oldUser.Panels));

        if(panelChanges?.length > 0) {
            changes.push(`Changes made to ${user.FirstName} ${user.LastName}:<ul>${panelChanges.map(c => `<li>${c}</li>`).join('')}</ul>`);
        }
        
        const approvedFunctionChanges = compareApprovedFunctions(oldUser?.ApprovedFunctions || {}, user?.ApprovedFunctions || {});

        if(approvedFunctionChanges?.length > 0) {
            changes.push(`Changes made to ${user.FirstName} ${user.LastName}:<ul>${approvedFunctionChanges.map(c => `<li>${c}</li>`).join('')}</ul>`);
        }

        //now check to seee if the user was removed / cancelled
        // if(!user.Active && oldUser.Active) {
        //     changes.push(`User ${user.FirstName} ${user.LastName} removed from the signatory matrix`);
        // } else if(user.Active && !oldUser.Active) {
        //     changes.push(`User ${user.FirstName} ${user.LastName} reactivated in the signatory matrix`);
        // }

        if (user.Cancelled && !oldUser.Cancelled) {
            changes.push(`User ${user.FirstName} ${user.LastName} removed from the signatory matrix`);
        } else if (!user.Cancelled && oldUser.Cancelled) {
            changes.push(`User ${user.FirstName} ${user.LastName} reactivated in the signatory matrix`);
        }
    }

    return changes.join('</br> ');
};

function buildNewUserPanels(user) {
    const panels = Object.values(user.Panels || {}).filter(p => p.Answer && p.Answer !== "None");
    if (panels.length === 0) return "";

    const items = panels.map(panel => {
        const panelMeta = store.state["Matrices/SignatoryMatrix/Panels"][panel.ID];
        const name = panelMeta?.Name || panel.ID;
        const limitations = Object.values(panel.Limitations || {}).map(l => l.Limitation).join(", ");
        return `<li>${name}: ${panel.Answer}${limitations ? ` — Limitations: ${limitations}` : ""}</li>`;
    });

    return `<ul>${items.join('')}</ul>`;
}

function comparePanelChanges(newPanels, oldPanels) {
    let allChanges = [];
    for (let newPanel of newPanels) {
        //get old panel by id
        let oldPanel = oldPanels.find(p => p.ID === newPanel.ID);

        //get panel meta
        const panelMeta = store.state["Matrices/SignatoryMatrix/Panels"][newPanel.ID];
        newPanel.meta = panelMeta;

        //add inital line for the changes of this panel

        //compare panel changes
        if (oldPanel) {
            let changes = comparePanel(oldPanel, newPanel);

            if (changes.length === 0) {
                continue;
            }

            //add changes to all changes
            allChanges = [...allChanges, ...changes];
        }
    };
    return allChanges
};

function comparePanel(oldPanel, newPanel) {

    let changes = [];
    
    if (oldPanel.Answer !== newPanel.Answer) {
        changes.push(`${newPanel.meta.Name} competency level changed from ${oldPanel.Answer} to ${newPanel.Answer}`);

    }
    if (newPanel.Limitations) {
        Object.entries(newPanel.Limitations).forEach(([key, value]) => {

            if(!get(oldPanel.Limitations, key, null)) {
                changes.push(`Limitiation added to ${newPanel.meta.Name}`);
                return;
            }

            if (oldPanel?.Limitations[key].Limitation !== value.Limitation) {
                changes.push(`${newPanel.meta.Name} changed to ${value.Limitation}`);
            }
        });
    }

    return changes;
}

function compareApprovedFunctions(oldFunctions, newFunctions) {
    
    const oldKeys = Object.keys(oldFunctions);
    const newKeys = Object.keys(newFunctions);

    const allChanges = [];

    for (let key of newKeys) {
        if (!oldKeys.includes(key)) {
            allChanges.push(`Approved Function ${store.state["Matrices/SignatoryMatrix/ApprovedFunctions"][key].Name} added`);
        }
    };
    for(let key of oldKeys) {
        if(!newKeys.includes(key)) {
            allChanges.push(`Approved Function ${store.state["Matrices/SignatoryMatrix/ApprovedFunctions"][key].Name} removed`);
        }
    }
    return allChanges
};
